export const START_EDIT = 'Entity/Affiliation/START_EDIT'
export const STOP_EDIT = 'Entity/Affiliation/STOP_EDIT'
